import Style from './style';
import './style.less';
export default Style;